import React, { useState, useEffect, useRef } from "react";
import {
	LanguageSwitcherContainer,
	LanguageMenu,
	LanguageMenuItem,
	LanguageSwitcherButton,
} from "./styles";
import { useTranslation } from "react-i18next";
import { useNavigate, useLocation } from "react-router-dom"; // Import navigation hooks

const LanguageSwitcher = () => {
	const { i18n } = useTranslation();
	const [languageMenuOpen, setLanguageMenuOpen] = useState(false);
	const languageMenuRef = useRef(null);
	const navigate = useNavigate(); // Use navigate to change URL
	const location = useLocation(); // Get the current URL

	const toggleLanguageMenu = () => setLanguageMenuOpen(!languageMenuOpen);

	const changeLanguage = (lang) => {
		i18n.changeLanguage(lang);
		setLanguageMenuOpen(false);

		// Extract the current path and update with the new language
		const pathWithoutLanguage = location.pathname.substring(3); // Remove first 3 characters (/en, /am, /ru)
		navigate(`/${lang}${pathWithoutLanguage}`); // Update the path with the new language
	};

	// Close language menu when clicking outside
	useEffect(() => {
		const handleClickOutside = (event) => {
			if (
				languageMenuRef.current &&
				!languageMenuRef.current.contains(event.target)
			) {
				setTimeout(() => {
					setLanguageMenuOpen(false);
				}, 100); // Short delay to allow language selection
			}
		};

		if (languageMenuOpen) {
			document.addEventListener("mousedown", handleClickOutside);
		}

		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, [languageMenuOpen]);

	return (
		<LanguageSwitcherContainer>
			<LanguageSwitcherButton onClick={toggleLanguageMenu}>
				{i18n.language.toUpperCase()}
			</LanguageSwitcherButton>
			{languageMenuOpen && (
				<LanguageMenu
					ref={languageMenuRef}
					initial={{ opacity: 0 }}
					animate={{ opacity: 1 }}
				>
					<LanguageMenuItem onClick={() => changeLanguage("en")}>
						English
					</LanguageMenuItem>
					<LanguageMenuItem onClick={() => changeLanguage("hy")}>
						Հայերեն
					</LanguageMenuItem>
					<LanguageMenuItem onClick={() => changeLanguage("ru")}>
						Русский
					</LanguageMenuItem>
				</LanguageMenu>
			)}
		</LanguageSwitcherContainer>
	);
};

export default LanguageSwitcher;
